import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			summaryBlocks: {
				props: {
					itemsPerRow: 3,
				},
				queries: {
					blocks: [
						{
							blankDataOptions: {
								placeholder: '-',
							},
							key: {
								queryOptionsType: 'none',
								value: 'nav',
							},
							subtitle: {
								code: 'key_facts',
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'NAV',
										},
									],
								},
								entityType: 'CLSS',
								format: {
									options: {
										day: '2-digit',
										month: '2-digit',
										placeholderKey: 'date',
										placeholderText: 'as of {date}',
										year: 'numeric',
									},
									type: 'date',
								},
								index: 0,
								key: 'date',
								queryOptionsType: 'statistics',
							},
							title: {
								queryOptionsType: 'none',
								value: 'NAV',
							},
							value: {
								code: 'key_facts',
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'NAV',
										},
									],
								},
								index: 0,
								entityType: 'CLSS',
								format: {
									options: {
										forceMinimumThresholdFormatting: false,
										maximumFractionDigits: 1,
										minimumFractionDigits: 1,
										numberThresholds: [
											{
												text: 'M',
												value: 1000000,
											},
											{
												text: 'B',
												value: 1000000000,
											},
											{
												text: 'T',
												value: 1000000000000,
											},
										],
									},
									type: 'number',
								},
								key: 'value',
								queryOptionsType: 'statistics',
							},
						},
						{
							blankDataOptions: {
								placeholder: '-',
							},
							key: {
								queryOptionsType: 'none',
								value: 'aum',
							},
							subtitle: {
								code: 'key_facts',
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'AUM',
										},
									],
								},
								entityType: 'CLSS',
								format: {
									options: {
										day: '2-digit',
										month: '2-digit',
										placeholderKey: 'date',
										placeholderText: 'as of {date}',
										year: 'numeric',
									},
									type: 'date',
								},
								index: 0,
								key: 'date',
								queryOptionsType: 'statistics',
							},
							title: {
								queryOptionsType: 'none',
								value: 'AUM',
							},
							tooltip: {
								title: {
									content: {
										queryOptionsType: 'disclaimers',
										key: 'Fees',
										entityType: 'CLSS',
									},
								},
							},
							value: {
								code: 'key_facts',
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'AUM',
										},
									],
								},
								index: 0,
								entityType: 'CLSS',
								format: {
									options: {
										forceMinimumThresholdFormatting: true,
										maximumFractionDigits: 1,
										minimumFractionDigits: 1,
										numberThresholds: [
											{
												text: 'M',
												value: 1000000,
											},
											{
												text: 'B',
												value: 1000000000,
											},
											{
												text: 'T',
												value: 1000000000000,
											},
										],
									},
									type: 'number',
								},
								key: 'value',
								queryOptionsType: 'statistics',
							},
						},
						{
							blankDataOptions: {
								showBlank: false,
							},
							dataType: {
								queryOptionsType: 'none',
								value: 'morningstar-rating',
							},
							key: {
								queryOptionsType: 'none',
								value: 'mstar',
							},
							morningstarRatingProps: {
								morningStarRating: {
									code: 'morningstar_rating',
									entityType: 'CLSS',
									queryOptionsType: 'property',
								},
							},
							title: {
								queryOptionsType: 'none',
								value: 'Morningstar Rating ™',
							},
						},
						{
							blankDataOptions: {
								showBlank: false,
							},
							dataType: {
								queryOptionsType: 'none',
								value: 'risk-rating',
							},
							key: {
								queryOptionsType: 'none',
								value: 'srri',
							},
							riskRatingProps: {
								labels: {
									bottom: {
										left: {
											queryOptionsType: 'none',
											value: 'Lower Risk',
										},
										right: {
											queryOptionsType: 'none',
											value: 'Higher Risk',
										},
									},
								},
								value: {
									code: 'key_facts',
									collectionItemValueConditional: {
										conditions: [
											{
												field: 'label',
												operator: '=',
												value: 'NAV',
											},
										],
									},
									index: 0,
									entityType: 'CLSS',
									format: {
										options: {
											forceMinimumThresholdFormatting: false,
											maximumFractionDigits: 1,
											minimumFractionDigits: 1,
											numberThresholds: [
												{
													text: 'M',
													value: 1000000,
												},
												{
													text: 'B',
													value: 1000000000,
												},
												{
													text: 'T',
													value: 1000000000000,
												},
											],
										},
										type: 'number',
									},
									key: 'value',
									queryOptionsType: 'statistics',
								},
							},
							title: {
								queryOptionsType: 'none',
								value: 'Risk and reward profile',
							},
						},
					],
				},
			},
			globalInputIdentifiers: [
				'my-custom-input',
			],
		},
	},
};
